import { AddTextEdit } from "./AddTextEdit";
import { Globals } from "../CoreApp/Globals.js";
import { QListeningTextEdit } from "../CoreApp/QListeningTextEdit.js";

export function AddListeningMultiLineTextEdit(
  panel,
  xPos,
  yPos,
  width,
  height,
  blankMsg,
  maxLen,
  tabID,
  addBorder,
  numRows
) {
  var te = new QListeningTextEdit();
  var teFill = Globals._themeMode.textedit.fill;
  var textColor = Globals._themeMode.text.header;
  te.InitTextEdit();
  te.SetNumRows(numRows);
  AddTextEdit(te, panel, xPos, yPos, width, height, blankMsg, maxLen, tabID, true);
  te.SetFillColor(teFill);
  te.SetFontColor(textColor);
  te.fParentPanel = panel;
  return te;
}
